export function User() {
  return {
    id: "",
    username: "",
    password: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    roleName: "",
    warehouseName: "",
    warehouseId: "",
    binIds: [],
    selectedBinList: [],
    binList: [],
    warehouse: new Warehouse(),
    shopName: "",
    shopId: "",
    shop: new Shop(),
    saleTeamId: "",
    branchId: "",
    ledgerBy: "",
    status: "",
    signature: "",
    image: "",
  };
}

export function Category() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
    accountId: "",
    accountCode: "",
    accountName: "",
    isLookUp: true,
  };
}

export function Brand() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
  };
}

export function Unit() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
  };
}

export function Warehouse() {
  return {
    id: "",
    name: "",
    code: "",
    location: "",
    imageUrl: "",
    image: "",
    description: "",
    status: "ACTIVE",
    type: "GROUND",
    backInTransfer: false,
    returnWarehouseId: "",
    binList: [],
    deleteBinIds: [],
  };
}

export function ProductGroup() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
    productGroupDetails: [],
    deleteProductGroupDetailIds: [],
  };
}

export function ProductGroupDetail() {
  return {
    id: "",
    productGroupId: 0,
    operationSettingId: 0,
  };
}

export function Product() {
  return {
    id: "",
    name: "",
    name2: "",
    code: "",
    description: "",
    status: "ACTIVE",
    brandName: "",
    categoryName: "",
    productGroupName: "",
    brandId: "",
    categoryId: "",
    productGroupId: "",
    imageUrl: "",
    image: "",
    productUnits: [],
    productItems: [],
    brand: new Brand(),
    category: new Category(),
    productGroup: new ProductGroup(),
    deleteProductUnitIds: [],
    deleteProductItemIds: [],
    maxQty: 0,
    minQty: 0,
    reorderQty: 0,
    productType: "STANDARD",
  };
}

export function ProductUnit() {
  return {
    id: "",
    factor: "",
    barcode: "",
    basicUnit: false,
    purchaseUnit: false,
    basicPriceflag: false,
    saleUnit: false,
    unitCost: 0.0,
    sellingPrice: 0.0,
    unitCostPercentage: 0,
    sellingPricePercentage: 0,
    wholeSaleSellingPrice: 0.0,
    wholeSaleSellingPricePercentage: 0,
    productId: "",
    unitName: "",
    factorUnitName: "",
  };
}

export function ProductItem() {
  return {
    id: "",
    productId: "",
    itemProuductId: "",
    itemProductName: "",
    itemProductCode: "",
    itemProductUnitId: "",
    itemProductUnitList: "",
    itemProductFactorUnitName: "",
    itemProductQty: 0,
    product: new Product(),
  };
}

export function StockTransfer() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    issueNo: "",
    requestNo: "",
    description: "",
    type: "",
    fromWarehouseName: "",
    toWarehouseName: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    stockTransferItems: [],
    deleteStockTransferItemIds: [],
    fromWarehouse: new Warehouse(),
    toWarehouse: new Warehouse(),
    serialNo: "",
  };
}

export function StockTransferItem() {
  return {
    id: "",
    qty: 0,
    remark: "",
    productCode: "",
    productName: "",
    stockTransferId: 0,
    productId: 0,
    productUnitId: 0,
    productUnits: [],
    stockQcNoDTOList: [],
    batchNoList: [],
    factorUnitName: "",
    qcNo: "",
    batchNo: "",
    mfgDate: "",
    mfgDateInMilliSeconds: "",
    expDate: "",
    expDateInMilliSeconds: "",
  };
}

export function StockIn() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    poNo: "",
    description: "",
    warehouse: new Warehouse(),
    warehouseName: "",
    type: "",
    status: "",
    isBackDateDataEntry: "",
    stockInItems: [],
    deleteStockInItemIds: [],
    serialNo: "",
  };
}

export function StockInItem() {
  return {
    id: "",
    qty: 0,
    unitCost: 0,
    sellingPrice: 0,
    discountPercent: 0,
    remark: "",
    stockInId: 0,
    productId: 0,
    productCode: "",
    productName: "",
    productUnitId: 0,
    factorUnitName: "",
    productUnits: [],
    poUnitCost: 0.0,
    basicUnitCost: 0.0,
    supplierId: "",
    countryId: "",
    countryName: "",
    supplierName: "",
    qcNo: "",
    batchNo: "",
    expDateInMilliSeconds: "",
    mfgDateInMilliSeconds: "",
  };
}

export function Tax() {
  return {
    id: "",
    name: "",
    percentage: "",
    taxType: "",
    status: "",
    description: "",
  };
}

export function StockAdjustment() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    warehouse: new Warehouse(),
    warehouseName: "",
    status: "",
    description: "",
    isBackDateDataEntry: "",
    stockAdjustmentItems: [],
    deleteStockAdjustmentItemIds: [],
    serialNo: "",
  };
}

export function StockAdjustmentItem() {
  return {
    id: "",
    qty: 0,
    remark: "",
    productCode: "",
    productName: "",
    stockAdjustmentId: 0,
    productUnitId: 0,
    productUnits: [],
    stockQcNoDTOList: [],
    batchNoList: [],
    factorUnitName: "",
    qcNo: "",
    batchNo: "",
    mfgDate: "",
    mfgDateInMilliSeconds: "",
    expDate: "",
    expDateInMilliSeconds: "",
  };
}

export function CounterCash() {
  return {
    id: "",
    counterName: "",
    cashType: "",
    amount: "",
    description: "",
    shopId: "",
    counterId: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
  };
}

export function Shop() {
  return {
    id: "",
    name: "",
    code: "",
    cityId: "",
    townshipId: "",
    address: "",
    phoneNo: "",
    createdBy: "",
    regionId: "",
    warehouseId: "",
    imageUrl: "",
    image: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    binIds: [],
  };
}
export function Sale() {
  return {
    id: "",
    saleNo: "",
    netAmount: 0,
    taxAmount: 0,
    payChange: 0,
    totalAmount: 0,
    discountAmount: 0.0,
    discountPercentage: 0,
    promotionAmount: 0,
    promotionPercentage: 0,
    username: "",
    shopId: 0,
    shopName: "",
    counterId: 0,
    counterName: "",
    payType: "",
    taxPercentage: 0,
    saleDate: "",
    saleItems: [],
    shiftAssignDetailId: 0,
    taxType: "ADD_ON",
    address: "",
    phoneNo: "",
    receivedAmount: 0,
    expenseAmount: 0,
    customerId: "",
    creditCashFlows: [],
    returnItems: [],
    notFocItems: [],
    focItems: [],
    backDateDataEntry: "INACTIVE",
    createdBy: "",
    createdDateInMilliSeconds: "",
    remark: "",
    isItemDiscount: false,
    isAdvancedAmount: false,
  };
}

export function SystemSerialize() {
  return {
    id: "",
    prefix: "",
    serializeNo: "",
    type: "",
    warehouseId: "",
    shopId: "",
    departmentId: "",
    status: "",
  };
}

export function ShiftInfo() {
  return {
    id: "",
    name: "",
    startHour: "00:00",
    endHour: "23:59",
    shopId: "",
    status: "",
  };
}

export function ShiftAssign() {
  return {
    id: "",
    assignDate: "",
    shiftAssignNo: "",
    shiftInfoId: "",
    shiftInfoName: "",
    assignDetailList: [],
    addAssignDetailList: [],
    deleteAssignDetailList: [],
  };
}

export function ShiftAssignDetail() {
  return {
    id: "",
    userId: "",
    username: "",
    counterId: "",
    counterName: "",
    status: true,
  };
}

export function Counter() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    shopId: "",
    status: true,
  };
}

export function StockTake() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    issueNo: "",
    warehouseId: 0,
    totalQty: 0,
    totalAmount: 0.0,
    stockTakeDetails: [],
  };
}

export function StockTakeDetail() {
  return {
    id: "",
    stockTakeId: 0,
    binId: 0,
    productId: 0,
    productUnitId: 0,
    qty: 0,
    unitCost: 0.0,
  };
}

export function Currency() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    defaultCurrency: "",
    status: "ACTIVE",
  };
}

export function CreditLevel() {
  return {
    id: "",
    name: "",
    periodDays: 0,
    description: "",
  };
}

export function CurrencyExchangeRate() {
  return {
    id: "",
    currencyId: "",
    currencyName: "",
    exchangeRate: "",
  };
}

export function Customer() {
  return {
    id: "",
    code: "",
    name: "",
    address: "",
    phoneNo: "",
    email: "",
    creditLevelId: "",
    townshipId: "",
    cityId: "",
    marginList: [],
    deleteMarginIds: [],
    regionId: "",
    priceModelId: "",
  };
}

export function PurchaseOrder() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    description: "",
    remark: "",
    purchaseType: "",
    status: "တင်ပြရန်ကျန်",
    supplierId: "",
    companyName: "",
    currencyId: "",
    warehouseId: "",
    warehouseName: "",
    procurementPlanId: null,
    procurementPlanNo: null,
    warehouse: new Warehouse(),
    purchaseOrderItems: [],
    purchaseOrderAssets: [],
    deletePurchaseOrderItemIds: [],
    deletePOAttachmentIds: [],
    purchasedExchangeRateMMK: 1,
    purchaseOrderType: "RAW",
  };
}

export function PurchaseOrderItem() {
  return {
    id: "",
    qty: 0,
    stockInQty: 0,
    basicUnitCost: 0,
    unitCost: 0,
    unitCostMMK: 0,
    actualUnitCost: 0,
    sellingPrice: 0,
    discountPercent: 0,
    remark: "",
    purchaseOrderId: "",
    productId: "",
    productCode: "",
    productName: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
    supplierId: "",
    supplierName: "",
    currencyId: "",
    currencyCode: "",
    currencyExchangeMMK: 1,
    approveNo: "",
    arrivalDateInMilliSeconds: "",
    qcPassQty: 0,
    tenderStartDateInMilliSeconds: "",
    tenderEndDateInMilliSeconds: "",
    dueDateInMilliSeconds: "",
    tenderQty: 0,
    periodDays: 0,
    tenderCommittee: "",
    tenderEC: "",
    countryId: "",
  };
}

export function PurchaseOrderAsset() {
  return {
    id: "",
    purchaseOrderId: "",
    assetId: "",
    countryId: "",
    assetName: "",
    unitId: "",
    unitName: "",
    supplierId: "",
    supplierName: "",
    currencyId: "",
    currencyCode: "",
    exchangeRate: 1,
    unitCost: 0,
    unitCostMMK: 0,
    sellingPrice: 0,
    discountPercent: 0,
    qty: 0,
    approveNo: "",
    approveDateInMilliSeconds: "",
    dueDateInMilliSeconds: "",
    arrivalDateInMilliSeconds: "",
    tenderStartDateInMilliSeconds: "",
    tenderEndDateInMilliSeconds: "",
    tenderQty: 0,
    tenderCommittee: "",
    tenderEC: "",
    remark: "",
  };
}

export function PurchaseOrderOrder() {
  return {
    issueDateInMilliSeconds: "",
    warehouseId: "",
    currencyId: "",
    orderIds: [],
    status: "PENDING",
    description: "",
    isItemDiscount: false,
    purchaseOrderOrderItems: [],
  };
}

export function PurchaseOrderOrderItem() {
  return {
    productId: "",
    productCode: "",
    productUnitId: "",
    orderQty: 0,
    unitCost: 0,
    sellingPrice: 0,
    supplierId: "",
  };
}

export function Supplier() {
  return {
    id: "",
    companyName: "",
    code: "",
    address: "",
    phone: "",
    email: "",
    contactPerson: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    supplierProductList: [],
    deleteSupplierProductIds: [],
    warehouseId: 0,
  };
}

export function SupplierProduct() {
  return {
    id: "",
    supplierId: "",
    productId: "",
    productCode: "",
    productName: "",
    productUnitId: "",
    factorUnitName: "",
    unitCost: 0,
    currencyId: "",
    currencyCode: "",
    currencyName: "",
    currencyExchangeRateId: "",
    exchangeRate: 1,
    unitCostMMK: 0,
    status: "ACTIVE",
    statusFlag: true,
  };
}

export function PriceModel() {
  return {
    id: "",
    name: "",
    description: "",
    status: "",
    priceModelDetailList: [],
    deletePriceModelDetailIds: [],
    regionId: "",
  };
}

export function Region() {
  return {
    id: "",
    name: "",
    description: "",
    currencyId: "",
    status: "",
    regionalProductList: [],
    deleteRegionalProductIds: [],
  };
}

export function RegionalProduct() {
  return {
    id: "",
    sellingPrice: 0,
    productId: "",
    productName: "",
    factorUnitName: "",
    productUnitId: "",
    unitCost: 0,
    unitCostPercentage: 0,
    sellingPricePercentage: 0,
    wholeSaleSellingPrice: 0,
    wholeSaleSellingPricePercentage: 0,
    productUnits: [],
    basicPriceflag: false,
  };
}

export function PriceModelDetail() {
  return {
    id: "",
    sellingPrice: 0,
    sellingPricePercentage: 0,
    priceModelId: "",
    productId: "",
    productName: "",
    factorUnitName: "",
    unitCost: 0,
    unitPrice: 0,
    productUnits: [],
  };
}

export function WholeSaleHeader() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    description: "",
    status: "DRAFT",
    deliveryInfo: "",
    netAmount: 0,
    taxAmount: 0,
    taxType: "ADD_ON",
    taxPercentage: 0,
    totalAmount: 0,
    discountAmount: 0,
    deliveryFee: 0,
    depositAmount: 0,
    customerId: "",
    shopId: "",
    customerName: "",
    shopName: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    wholeSaleDetails: [],
    deleteWholeSaleDetailIds: [],
    marginList: [],
    isItemDiscount: false,
    isAdvancedAmount: false,
    priceModelId: "",
    orderId: "",
    orderNo: "",
    discountPercentage: 0,
    promotionAmount: 0,
    promotionPercentage: 0,
    isWholesale: true,
    salePrintCount: 0,
    saleOrderPrintCount: 0,
    orderDateInMilliSeconds: "",
    orderNoText: "",
  };
}

export function CreditCashFlow() {
  return {
    id: "",
    createdBy: "",
    paidDateInMilliSeconds: 0,
    paidAmount: "",
    description: "",
    saleId: "",
    wholeSaleId: "",
  };
}

export function StockIssue() {
  return {
    id: "",
    issueNo: "",
    wholeSaleIssueNo: "",
    reason: "",
    warehouse: new Warehouse(),
    warehouseName: "",
    warehouseId: "",
    isBackDateDataEntry: "",
    stockIssueItems: [],
    serialNo: "",
  };
}

export function StockIssueItem() {
  return {
    id: "",
    qty: 0,
    remark: "",
    productCode: "",
    productName: "",
    stockIssueId: 0,
    productId: 0,
    productUnitId: 0,
    productUnits: [],
    stockQcNoDTOList: [],
    batchNoList: [],
    factorUnitName: "",
    binId: "",
    qcNo: "",
    batchNo: "",
    mfgDate: "",
    mfgDateInMilliSeconds: "",
    expDate: "",
    expDateInMilliSeconds: "",
  };
}

export function City() {
  return {
    id: "",
    name: "",
    description: "",
    townships: [],
  };
}

export function Township() {
  return {
    id: "",
    name: "",
    description: "",
    cityId: "",
  };
}

export function CustomerShop() {
  return {
    id: "",
    name: "",
    code: "",
    type: "",
    description: "",
    address: "",
    phoneNo: "",
    locationX: "",
    locationY: "",
    cityId: "",
    townshipId: "",
    customerId: "",
    shopTypeId: "",
    priceModelId: "",
    priceModelName: "",
    city: new City(),
    township: new Township(),
    customer: new Customer(),
    shopTypeDTO: new ShopType(),
  };
}

export function Way() {
  return {
    id: "",
    name: "",
    status: "ACTIVE",
    description: "",
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
    wayCustomerShops: [],
    deleteWayCustomerShopIds: [],
  };
}

export function OperationSetting() {
  return {
    id: "",
    name: "",
    auto: "",
    wipOS: false,
    description: "",
    operationSettingDetails: [],
    operationSettingDetailIds: [],
    deleteOperationSettingDetailIds: [],
  };
}

export function OperationSettingDetail() {
  return {
    id: "",
    accountId: "",
    accountName: "",
    code: "",
    accountType: "",
  };
}

export function LayoutSetting() {
  return {
    id: "",
    name: "",
    code: "",
    status: "ACTIVE",
    description: "",
    layoutType: "",
    sessionName: "",
    deleteDetailIds: [],
    layoutSettingDetailList: [],
  };
}

export function LayoutSettingDetail() {
  return {
    id: "",
    accountId: "",
    accountName: "",
    accountCode: "",
    isSubtract: false,
    isPreviousTrial: false,
    carryOn: false,
  };
}

export function WayAssign() {
  return {
    id: "",
    wayAssignDateInMilliSeconds: 0,
    wayAssignNo: "",
    description: "",
    status: "START",
    completeDateInMilliSeconds: 0,
    wayId: "",
    userId: "",
  };
}

export function StockTemplate() {
  return {
    id: "",
    name: "",
    description: "",
    status: "ACTIVE",
    stockTemplateItems: [],
    deleteStockTemplateItemIds: [],
  };
}

export function StockTemplateItem() {
  return {
    id: "",
    qty: 0,
    stockTemplateId: "",
    productId: "",
    productCode: "",
    productName: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
  };
}

export function Margin() {
  return {
    id: "",
    level: "",
    name: "",
    percentage: "",
    customerId: "",
    customer: new Customer(),
  };
}

export function ShopType() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
  };
}

export function Country() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
  };
}

export function BinType() {
  return {
    id: "",
    typeName: "",
    typeCode: "",
    description: "",
  };
}

export function AccountHead() {
  return {
    id: "",
    prefixNo: "",
    accountName: "",
    status: "",
  };
}

export function ChartOfAccount() {
  return {
    id: "",
    code: "",
    accName: "",
    accountTypeName: "",
    nature: "",
    totalOpeningBalance: 0,
    accountheadId: "",
    subAccountList: [],
    deleteSubAccountIds: [],
    status: "",
    carryOn: false,
  };
}

export function TrialBalance() {
  return {
    id: "",
    trialBalanceType: "",
    shopCode: "",
    status: "DRAFT",
    financeSettingId: "",
    yearAndMonthInMilliSeconds: "",
    yearAndMonth: "",
    trialBalanceDetailList: [],
  };
}

export function IncomeStatement() {
  return {
    id: "",
    code: "",
    year: "",
    fromMonth: "",
    toMonth: "",
    profitLossAmount: 0,
    shopId: "",
    totalRevenue: 0,
    totalCostOfGoodSold: 0,
    grossProfit: 0,
    totalOtherIncome: 0,
    totalAdministrationExpense: 0,
    totalSellingAndDistributionExpense: 0,
    incomeStatementAccountList: [],
  };
}

export function BalanceSheet() {
  return {
    id: "",
    code: "",
    year: "",
    liaEquaAmount: 0,
    totalAssetAmount: 0,
    shopId: "",
    currentAssetAmount: 0,
    nonCurrentAssetAmount: 0,
    equityAmount: 0,
    currentLiabilitiesAmount: 0,
    nonCurrentLiabilitiesAmount: 0,
    balanceSheetAccountList: [],
  };
}

export function Asset() {
  return {
    id: "",
    branchId: "",
    shopId: "",
    departmentId: "",
    chartOfAccountId: "",
    chartOfAccountName: "",
    cost: 0,
    recoveryPeriod: 0,
    percentage: 0,
    salvageValue: 0,
    depreciationStatus: "",
    depreciationType: "MONTHLY",
    startPeriodString: "",
    date: "",
    dateInMilliSeconds: "",
    assetName: "",
    assetType: "",
    unitId: "",
    qty: 0,
    budgetAmount: 0,
    purchaseAmount: 0,
    operationSettingId: "",
    description: "",
    assetDetailList: [],
    deleteAssetDetailIds: [],
  };
}

export function Bin() {
  return {
    id: "",
    name: "",
    warehouse: new Warehouse(),
    warehouseId: "",
    binType: new BinType(),
    binTypeId: "",
    maxCapacity: "",
    minCapacity: "",
    stockBalance: "",
    selfExpireInMilliSeconds: "",
    status: "",
    isPrimaryBin: false,
  };
}

export function LetterHead() {
  return {
    id: "",
    imageUrl: "",
    shopId: "",
    type: "",
  };
}

export function MaterialSession() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
  };
}

export function AccountReceivable() {
  return {
    id: "",
    issueNo: "",
    issueDateInMilliSeconds: "",
    fromDateInMilliSeconds: "",
    toDateInMilliSeconds: "",
    customerId: "",
    arType: "",
    creditAmount: 0,
    cashAmount: 0,
    accountReceiveStatus: "DRAFT",
    remark: "",
    advancedIssueNo: "",
  };
}

export function AccountPayable() {
  return {
    id: "",
    issueNo: "",
    issueDateInMilliSeconds: "",
    fromPODateInMilliSeconds: "",
    toPODateInMilliSeconds: "",
    supplierId: "",
    creditAmount: 0,
    cashAmount: 0,
    accountPayableStatus: "DRAFT",
    accountPayableDetailList: [],
    accountPayableItemList: [],
    deleteAccountPayableItemIds: [],
    accountPayableDetailAssetList: [],
    deleteAccountPayableDetailAssetIds: [],
    poNo: "",
    remark: "",
    apType: "PURCHASE_PAYMENT",
    shopId: "",
    currencyId: "",
    exchangeRateMMK: 1,
    cashAmountMMK: 0,
    creditAmountMMK: 0,
    advancedIssueNo: "",
  };
}

export function AccountPayableItem() {
  return {
    id: "",
    qty: 0,
    price: 0,
    priceMMK: 0,
    remark: "",
    productName: "",
    productId: 0,
    productUnitId: 0,
    productUnits: [],
    factorUnitName: "",
    amount: 0,
    amountMMK: 0,
    paidPercent: 0,
    paidAmount: 0,
    prevPaidPercent: 0,
  };
}

export function AccountPayableDetail() {
  return {
    id: "",
    purchaseOrderId: "",
    payableAmount: 0,
    payableAmountMMK: 0,
  };
}

export function AccountPayableDetailAsset() {
  return {
    id: "",
    qty: 0,
    price: 0,
    priceMMK: 0,
    remark: "",
    productName: "",
    productId: 0,
    productUnitId: 0,
    productUnits: [],
    factorUnitName: "",
    amount: 0,
    amountMMK: 0,
    paidPercent: 0,
    paidAmount: 0,
    prevPaidPercent: 0,
  };
}

export function StockTransferRequest() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    issueNo: "",
    description: "",
    fromWarehouseId: 0,
    toWarehouseId: 0,
    fromWarehouseName: "",
    toWarehouseName: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    stockTransferRequestItems: [],
    deleteStockTransferRequestItemIds: [],
    fromWarehouse: new Warehouse(),
    toWarehouse: new Warehouse(),
  };
}

export function StockTransferRequestItem() {
  return {
    id: "",
    qty: 0,
    remark: "",
    stockTransferRequestId: 0,
    productId: 0,
    productCode: "",
    productName: "",
    productUnitId: 0,
    factorUnitName: "",
    productUnits: [],
  };
}

export function Order() {
  return {
    id: "",
    orderDateInMilliSeconds: "",
    orderNo: "",
    deliveryAddress: "",
    billingAddress: "",
    binTypeId: "",
    maxCapacity: "",
    minCapacity: "",
    stockBalance: "",
    warehouseId: "",
    selfExpireInMilliSeconds: "",
    status: "",
    isSaveInWholeSale: true,
  };
}

export function LocationMovement() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    referenceNo: "",
    description: "",
    fromWarehouseId: "",
    toWarehouseId: "",
    fromBinId: "",
    toBinId: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    locationMovementDetailItems: [],
    deleteLocationMovementDetailItemIds: [],
    fromWarehouse: new Warehouse(),
    toWarehouse: new Warehouse(),
    serialNo: "",
  };
}

export function LocationMovementDetail() {
  return {
    id: "",
    qty: 0,
    remark: "",
    locationMovementId: "",
    productId: "",
    productCode: "",
    productName: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
    stockQcNoDTOList: [],
    batchNoList: [],
    qcNo: "",
    batchNo: "",
    mfgDate: "",
    mfgDateInMilliSeconds: "",
    expDate: "",
    expDateInMilliSeconds: "",
  };
}

export function DamageHeader() {
  return {
    id: "",
    shopId: "",
    damageStatus: "DRAFT",
    customerName: "",
    invoiceType: "",
    customerId: "",
    remark: "",
    taxAmount: 0,
    discountAmount: 0,
    promotionAmount: 0,
    expenseAmount: 0,
    totalAmount: 0,
    damageDetailList: [],
    deleteDamageDetailIds: [],
    isItemDiscount: false,
    creditInvoiceType: "NO_INVOICE",
    creditInvoiceId: "",
    creditRemainingAmount: 0,
    backInStock: false,
    backInStockWarehouseId: "",
    backInStockBinId: "",
    creditNoteNo: "",
  };
}

export function DamageDetail() {
  return {
    id: "",
    qty: 0,
    price: 0,
    remark: "",
    productName: "",
    productId: 0,
    productUnitId: 0,
    productUnits: [],
    factorUnitName: "",
    discountPercent: 0,
    qcNo: "",
    batchNo: "",
    mfgDate: "",
    mfgDateInMilliSeconds: "",
    expDate: "",
    expDateInMilliSeconds: "",
  };
}

export function OrderHeader() {
  return {
    id: "",
    orderDateInMilliSeconds: "",
    orderNo: "",
    customerId: "",
    customerDTO: new Customer(),
    customerShopId: "",
    shopId: "",
    cityId: "",
    townshipId: "",
    userId: "",
    deliveryAddress: "",
    isSaveInWholeSale: false,
    billingAddress: "",
    estimateDeliveryDateInMilliSeconds: "",
    csRequestDateInMilliSeconds: "",
    orderStatus: "",
    approvedUserId: "",
    approvedDateInMilliSeconds: "",
    phoneNo: "",
    discountAmount: 0,
    discountPercent: 0,
    promotionAmount: 0,
    promotionPercent: 0,
    deliveryFee: 0,
    adminRemark: "",
    remark: "",
    totalAmount: 0,
    isItemDiscount: false,
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    orderHeadDetails: [],
    deleteOrderDetailIds: [],
  };
}

export function OrderHeadDetail() {
  return {
    id: "",
    productId: "",
    productDTO: new Product(),
    productName: "",
    productUnitId: "",
    productUnitDTO: new ProductUnit(),
    orderQty: 0,
    availableQty: 0,
    confirmQty: 0,
    deliveryQty: 0,
    defectQty: 0,
    price: 0,
    remark: "",
    discountPercent: 0,
    factorUnitName: "",
    productUnits: [],
    totalPrice: 0,
    saleQty: 0,
  };
}

export function AccountType() {
  return {
    id: "",
    code: "",
    accTypeName: "",
    accTypeNature: "",
    status: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
  };
}

export function GeneralLedger() {
  return {
    id: "",
    ledgerNo: "",
    chequeNo: "",
    invoiceNo: "",
    ledgerDateInMilliSeconds: "",
    amount: 0.0,
    status: "DRAFT",
    type: "LEDGER",
    description: "",
    reference: "",
    currencyId: "",
    shopId: "",
    debitAccountId: "",
    creditAccountId: "",
    financeSessionId: "",
    operationSettingId: "",
    generalLedgerAttachments: [],
    generalLedgerDetailList: [],
    deleteGeneralLedgerAttachmentIds: [],
    deleteGeneralLedgerDetailIds: [],
  };
}

export function GeneralLedgerDetail() {
  return {
    id: "",
    accountId: "",
    accountName: "",
    code: "",
    accountType: "",
    amount: 0,
  };
}

export function GeneralLedgerAttachment() {
  return {
    id: "",
    fileName: "",
    generalLedgerId: "",
  };
}

export function FinanceSession() {
  return {
    id: "",
    code: "",
    shopId: "",
    yearMonth: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    financeSettingId: "",
  };
}

export function FinanceSetting() {
  return {
    id: "",
    code: "",
    financialYearName: "",
    startMonth: "",
    endMonth: "",
    description: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
  };
}

export function Branch() {
  return {
    id: "",
    code: "",
    name: "",
    description: "",
    address: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
  };
}

export function CategoryGroup() {
  return {
    id: "",
    name: "",
    code: "",
    status: "ACTIVE",
    description: "",
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
    categoryGroupDetailList: [],
    deleteCategoryGroupDetailIds: [],
  };
}

export function SaleTeam() {
  return {
    id: "",
    code: "",
    name: "",
    description: "",
    status: "ACTIVE",
    saleTeamDetailList: [],
    deleteSaleTeamDetailIds: [],
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
  };
}

export function SaleTeamDetail() {
  return {
    id: "",
    saleTeamId: "",
    customerId: "",
    customerCode: "",
    customerName: "",
  };
}

export function EMR() {
  return {
    id: "",
    issueNo: "",
    issueDateInMilliSeconds: "",
    reason: "",
    serialNo: "",
    status: "DRAFT",
    departmentId: "",
    shopId: "",
    warehouseId: "",
    binId: "",
    emrDetailList: [],
    deleteEMRDetailIds: [],
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
    type: "EMR",
  };
}

export function EMRDetail() {
  return {
    id: "",
    emrHeaderId: "",
    productId: "",
    productCode: "",
    productName: "",
    productUnitId: "",
    productUnits: [],
    stockQcNoDTOList: [],
    batchNoList: [],
    factorUnitName: "",
    qty: 0,
    unitCost: "",
    jobNo: "",
    remark: "",
  };
}

export function ProductionItem() {
  return {
    id: "",
    code: "",
    name: "",
    description: "",
    status: "ACTIVE",
    productionItemDetailList: [],
    deleteProductionItemDetailIds: [],
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
  };
}

export function ProductionItemDetail() {
  return {
    id: "",
    productionItemId: "",
    processName: "",
    percentage: 0,
    remark: "",
  };
}

export function StoreReturnNote() {
  return {
    id: "",
    issueNo: "",
    issueDateInMilliSeconds: "",
    reason: "",
    status: "DRAFT",
    departmentId: "",
    shopId: "",
    warehouseId: "",
    binId: "",
    storeReturnNoteDetailList: [],
    deleteStoreReturnNoteDetailIds: [],
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
  };
}

export function StoreReturnNoteDetail() {
  return {
    id: "",
    storeReturnNoteHeaderId: "",
    productId: "",
    productCode: "",
    productName: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
    qty: 0,
    issueQty: 0,
    unitCost: "",
    jobNo: "",
    remark: "",
  };
}

export function QC() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    qcNo: "",
    warehouseId: "",
    warehouseName: "",
    purchaseOrderId: "",
    purchaseOrderNo: "",
    status: "DRAFT",
    purchaseOrderItemId: "",
    productId: "",
    productName: "",
    productCode: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
    supplierId: "",
    supplierName: "",
    qcQty: 0,
    countryId: "",
    countryName: "",
    receivedDateInMilliSeconds: "",
    batchLotNo: "",
    mfgDateInMilliSeconds: "",
    expDateInMilliSeconds: "",
    reference: "",
    manufacturer: "",
    samplingDateInMilliSeconds: "",
    testCompletionDateInMilliSeconds: "",
    remark: "",
  };
}

export function Department() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
  };
}

export function ProductionOrder() {
  return {
    id: "",
    issueNo: "",
    issueDateInMilliSeconds: "",
    poNo: "",
    productionPlanNo: "",
    warehouseId: "",
    WarehouseName: "",
    shopId: "",
    shopName: "",
    fromDepartmentId: "",
    fromDepartmentName: "",
    toDepartmentId: "",
    toDepartmentName: "",
    productId: "",
    productName: "",
    productCode: "",
    productUnitId: "",
    factorUnitName: "",
    factor: 1,
    productUnits: [],
    qty: 0,
    batchNo: "",
    remark: "",
    status: "DRAFT",
    mfgDateInMilliSeconds: "",
    expDateInMilliSeconds: "",
    productionOrderDetailList: [],
    deleteProductionOrderDetailIds: [],
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
    productionQty: 0,
    productionProductUnitId: "",
    productionProductUnitName: "",
    productionProductUnitFactor: 1,
    productionFactorUnitName: "",
  };
}

export function ProductionOrderDetail() {
  return {
    id: "",
    productionOrderHeaderId: "",
    itemProductId: "",
    itemProductName: "",
    itemProductCode: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
    stockQcNoDTOList: [],
    batchNoList: [],
    qcNo: "",
    itemQty: 0,
    issueQty: 0,
    usageQty: 0,
    specialInstruction: "",
  };
}

export function ManufacturingCost() {
  return {
    id: "",
    code: "",
    name: "",
    status: "ACTIVE",
    createdBy: "",
    updatedBy: "",
    createdDateInMilliSeconds: "",
    updatedDateInMilliSeconds: "",
  };
}

export function ProductionHeader() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    name: "",
    shopId: "",
    description: "",
    productionOrderNo: "",
    productionOrderAndPoNo: "",
    emrNos: "",
    emrIds: "",
    productionWarehouseId: "",
    productionBinId: "",
    outputWarehouseId: "",
    outputBinId: "",
    status: "DRAFT",
    wipPercent: 0,
    productionItemId: "",
    productionItemDetailId: "",
    createdBy: "",
    updatedBy: "",
    createdDateInMilliSeconds: "",
    updatedDateInMilliSeconds: "",
    productionDetailList: [],
    productionCostList: [],
    deleteProductionCostIds: [],
    deleteProductionDetailIds: [],
  };
}

export function ProductionDetail() {
  return {
    id: "",
    //productionHeaderId: "",
    //type: "",
    productId: "",
    productCode: "",
    productName: "",
    factor: 1,
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
    qcNo: "",
    batchNo: "",
    mfgDate: "",
    expDate: "",
    expDateInMilliSeconds: "",
    mfgDateInMilliSeconds: "",
    unitCost: 0,
    poQty: 0,
    poUsageQty: 0,
    emrQty: 0,
    emrUsageQty: 0,
    rmrQty: 0,
    rmrUsageQty: 0,
    expectedQty: 0,
    actualQty: 0,
    remark: "",
    stockProducts: [],
    stockQcNoDTOList: [],
    batchNoList: [],
    totalAmount: 0,
    currentStockQty: 0,
    oldPoUsageQty: 0,
    oldEmrUsageQty: 0,
    oldRmrUsageQty: 0,
  };
}

export function ProductionCost() {
  return {
    id: "",
    //productionHeaderId: "",
    manufacturingCostId: "",
    manufacturingCostCode: "",
    manufacturingCostName: "",
    unitCost: 0,
    expectedCost: 0,
    actualCost: 0,
    remark: "",
  };
}

export function MaintenanceFrequency() {
  return {
    id: "",
    name: "",
    serialNo: "",
    description: "",
    status: "ACTIVE",
  };
}

export function MaintenanceType() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
    preventiveMaintenance: false,
  };
}

export function MachineType() {
  return {
    id: "",
    name: "",
    code: "",
    description: "",
    status: "ACTIVE",
  };
}

export function CheckListFrequency() {
  return {
    id: "",
    name: "",
    serialNo: "",
    description: "",
    status: "ACTIVE",
  };
}

export function Machine() {
  return {
    id: "",
    shopId: "",
    departmentId: "",
    branchId: "",
    code: "",
    name: "",
    unitId: "",
    qty: 0,
    model: "",
    capacity: "",
    countryId: "",
    installationData: "",
    lifeCycle: "",
    maintenanceTypeId: "",
    machineTypeId: "",
    maintenanceFrequencyId: "",
    remark: "",
    description: "",
    status: "ACTIVE",
    purchaseOrderAmount: 0,
    currentAmount: 0,
    machineDetailList: [],
    machineChecklistDetailList: [],
    deleteMachineDetailIds: [],
    deleteMachineChecklistDetailIds: [],
    createdBy: "",
    updatedBy: "",
    createdDateInMilliSeconds: "",
    updatedDateInMilliSeconds: "",
  };
}

export function MachineDetail() {
  return {
    id: "",
    failureMode: "",
    dateInMilliSeconds: "",
    date: "",
    failureItem: "",
    correctiveAction: "",
    frequency: 0,
    maintenanceAmount: 0,
  };
}

export function MachineChecklistDetail() {
  return {
    id: "",
    location: "",
    workDescription: "",
    maintenanceFrequencyIds: [],
    maintenanceRemark: "",
    checklistFrequencyIds: [],
    checklistRemark: "",
  };
}

export function BudgetHeader() {
  return {
    id: "",
    issueDateInMilliSeconds: 0,
    issueNo: "",
    financeSettingId: "",
    shopId: "",
    description: "",
    createdBy: "",
    createdDateInMilliSeconds: 0,
    updatedBy: "",
    updatedDateInMilliSeconds: 0,
    budgetDetailList: [],
    deleteBudgetDetailIds: [],
  };
}

export function BudgetDetail() {
  return {
    id: "",
    budgetId: "",
    accountId: "",
    accountCode: "",
    accountName: "",
    accountType: "",
    parentAccountName: "",
    budgetAmount: 0,
    remark: "",
  };
}

export function ProcurementPlan() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    planYear: "",
    warehouseId: "",
    warehouseName: "",
    type: "စက်ရုံBOD",
    status: "DRAFT",
    description: "",
    remark: "",
    procurementPlanType: "RAW",
    warehouse: new Warehouse(),
    purchasePlanItemList: [],
    procurementPlanAssetList: [],
    deletePurchasePlanItemIds: [],
  };
}

export function PurchasePlanItem() {
  return {
    id: "",
    procurementPlanId: "",
    productId: "",
    productName: "",
    productCode: "",
    factorUnitName: "",
    productUnitId: "",
    productUnits: [],
    factor: 1,
    product: "",
    currencyId: "",
    currencyCode: "",
    currency: "",
    planQty: 0,
    poQty: 0,
    unitCost: 0,
    totalCost: 0,
    description: "",
    remark: "",
  };
}

export function PurchasePlanAsset() {
  return {
    id: "",
    procurementPlanId: "",
    assetId: "",
    assetName: "",
    unitId: "",
    unitName: "",
    currencyId: "",
    currencyCode: "",
    planQty: 0,
    poQty: 0,
    unitCost: 0,
    totalCost: 0,
    description: "",
    remark: "",
  };
}

export function ProductionPlan() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    shopId: "",
    warehouseId: "",
    departmentId: "",
    status: "DRAFT",
    description: "",
    productionPlanDetailList: [],
    deleteProductionPlanDetailIds: [],
  };
}

export function ProductionPlanDetail() {
  return {
    id: "",
    productionPlanId: "",
    productId: 0,
    productCode: "",
    productName: "",
    productUnitId: 0,
    factorUnitName: "",
    productUnits: [],
    planQty: 0,
    oldPlanQty: 0,
    productionOrderQty: 0,
    remark: "",
  };
}

export function ProductionCosting() {
  return {
    id: "",
    issueDateInMilliSeconds: "",
    issueNo: "",
    shopId: "",
    manufacturingCostId: "",
    month: "",
    status: "DRAFT",
    description: "",
    productionCostingDetailList: [],
    deleteProductionCostingDetailIds: [],
    createdBy: "",
    createdDateInMilliSeconds: "",
    updatedBy: "",
    updatedDateInMilliSeconds: "",
  };
}

export function ProductionCostingDetail() {
  return {
    id: "",
    productionCostingId: "",
    productId: "",
    productUnitId: "",
    factorUnitName: "",
    productUnits: [],
    productionHeaderIds: [],
    productionQty: 0,
    actualQty: 0,
    unitCost: 0,
  };
}

export function ManufacturingAccount() {
  return {
    id: "",
    code: "",
    year: "",
    fromMonth: "",
    toMonth: "",
    shopId: "",
    originalCost: 0.0,
    productionCost: 0.0,
    productionValue: 0.0,
    valueOfGoodsSlod: 0.0,
    totalProductionCost: 0.0,
    totalProductionValue: 0.0,
    totalValueOfGoodsSlod: 0.0,
    originalCostBudget: 0.0,
    productionCostBudget: 0.0,
    productionValueBudget: 0.0,
    valueOfGoodsSlodBudget: 0.0,
    totalProductionCostBudget: 0.0,
    totalProductionValueBudget: 0.0,
    totalValueOfGoodsSlodBudget: 0.0,
    manufacturingParentAccountList: [],
  };
}
